import { HubAPI } from './hub';

class API extends HubAPI {
  apiPath = '_ui/v1/execution-environments/remotes/';

  // list(params?)
  // create(data)
  // get(pk)
  // update(pk, data)

  sync(name) {
    const apiPath = 'v3/plugin/execution-environments/repositories/';
    return this.http.post(apiPath + name + '/_content/sync/', {});
  }
}

export const ExecutionEnvironmentRemoteAPI = new API();
